import styled from 'styled-components';

//check-div
export const CellValueBoolDefaultBox = styled.div`
    width: 13px;
    height: 13px;
    float: right;
    background-image: url("${props => props.theme.assets.images.check_png.toString()}");
    background-repeat: no-repeat;
`;